
import React, { useEffect, useState } from 'react';
import { Interview } from '@/types/interview';
import { Dialog, DialogContent, DialogHeader } from '@/components/ui/dialog';
import InterviewEditor from './InterviewEditor';
import { EnhancedDialogTitle } from '@/lib/shadcn-enhanced';

interface EditInterviewDialogProps {
  interview: Interview | null;
  isOpen: boolean;
  onClose: () => void;
}

const EditInterviewDialog: React.FC<EditInterviewDialogProps> = ({
  interview,
  isOpen,
  onClose
}) => {
  const [editorKey, setEditorKey] = useState(Date.now());
  
  // Always call hooks unconditionally at the top level
  useEffect(() => {
    if (isOpen && interview) {
      console.log('[EditInterviewDialog] Dialog opened with interview:', {
        id: interview.id,
        name: interview.intervieweeName,
        hasPhotoUrl: !!interview.photoUrl,
        photoUrl: interview.photoUrl || 'No photo URL',
        hasContextUrl: !!interview.contextUrl, 
        contextUrl: interview.contextUrl || 'No context URL',
        timestamp: interview.timestamp
      });
      
      // Force a re-render of the editor every time dialog opens
      setEditorKey(Date.now());
    }
  }, [interview, isOpen]);

  // Return null for the entire component if no interview
  if (!interview) {
    return null;
  }

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <EnhancedDialogTitle>Rediger Intervju</EnhancedDialogTitle>
        </DialogHeader>
        
        <InterviewEditor 
          key={editorKey}
          interview={{
            ...interview,
            photoUrl: interview.photoUrl || '',
            photoUrl2: interview.photoUrl2 || '',
            contextUrl: interview.contextUrl || '',
            updated_at: new Date().toISOString() // Always force an updated_at timestamp
          }}
          onClose={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};

export default EditInterviewDialog;
